import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getWithdrawalReport = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/withdrawal_report`,
    );
  }
  return http.get(
    `${getBaseUrl()}/withdrawal_report?${paginate}`,
  );
};